import { createFormItem } from "@/component-create/utils/create-form-item"
import { FormDialog } from "@/component-create/FormDialog"
import { FORM_ITEM } from "@/components/form/enums"

import { DICTIONARY_CODE } from "@/utils/pattern"
import { BASE_URL } from "@/api/system/dictionary"

/**
 * 绘制编辑表单
 */
export function renderEditForm(el: Element) {
  const editForm = new FormDialog(
    el, 
    { 
      items: items, 
      elFormProps: { rules: rules }, 
      saveUrl: BASE_URL,
      loadUrl: BASE_URL,
      saveMethods: 'put'
    },
    '编辑'
  )

  return editForm
}

const items = [
  [
    createFormItem('字典名称', 'dictionaryName', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' })
  ],
  [
    createFormItem('字典编码', 'dictionaryCode', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' }),
  ],
  [
    createFormItem('字典状态', 'status', FORM_ITEM.SELECT, { loader: 'EOD' }),
  ],
  [
    createFormItem('备注', 'remark', FORM_ITEM.INPUT, { type: 'textarea', rows: 3, maxlength: '200', showWordLimit: true }),
  ]
]
const rules = {
  dictionaryName: [{ required: true, message: '请输入字典名称', trigger: 'blur' }],
  dictionaryCode: [{ required: true, message: '请输入字典编码', trigger: 'blur' },
    { pattern: DICTIONARY_CODE, message: '只能包含小写字母、数字、下划线', trigger: 'blur' }],
  status: [{ required: true, message: '请选择状态', trigger: 'blur' }]
}